<template>
  <a @click="clickLink()" :style="linkStyle">{{ value }}</a>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      clicked: false,
    };
  },

  computed: {
    linkStyle: function () {
      let color;
      if (this.clicked) {
        color = "#681da8";
      } else {
        color = "#0066ba";
      }
      return "text-decoration: underline; color:" + color;
    },
  },

  methods: {
    clickLink: function () {
      this.clicked = true;
      this.$emit("click");
      return;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/Link.vue